/*
   Define a list of available report types.
 */
export enum FinancialReportType {
    AnnualReports = 'Annual Reports',
    InterimReport = 'Interim report',
}
